import { useSelector } from "react-redux";
import { CoreServices } from "../../../base/service/apiServices";
import { supervisorContactDataSliceActions } from "../../../store/slices/supervisor_contact/contactsData";
import { agentTrackerActions } from "../../../store/slices/trackerStatus_slice/agentTrackerslice";
import store from "../../../store/redux-store/root_store";

export const numnberPattern = /^[0-9]+$/;
export const emailPattern = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


export const getDNDContactRequest = (dispatch: any) => {

  try {
    CoreServices.get(`/get_donotdisturb_customer_contact_request`).then((value: any) => {
      if (value.data.statusCode === 200) {

        dispatch(
          supervisorContactDataSliceActions.dndContactsRequest({
            dnd_contactsRequest: value.data.getDoNotDisturbCustomerReqListRes,

          })
        );
      } else {
        dispatch(
          supervisorContactDataSliceActions.dndContactsRequest({
            dnd_contactsRequest: [],
          })
        )
      }
    })
  } catch (error) {
    console.log(error, "get_donotdisturb_customer_request___ERROR")
  }
}

export const getDNDContact = (dispatch: any) => {
  try {
    CoreServices.get(`/get_donotdisturb_customer_contact`).then((value: any) => {
      if (value.data.statusCode === 200) {
        dispatch(
          supervisorContactDataSliceActions.dndContacts({
            dnd_contacts: value.data.getDoNotDisturbCustomerListRes,
          })
        );
      } else {
        dispatch(
          supervisorContactDataSliceActions.dndContacts({
            dnd_contacts: [],
          })
        );
      }
    })
  }
  catch (error) {
    console.log(error, "get_donotdisturb_customer___ERROR")
  }
}

export const getBlockData = (dispatch: any) => {
try {
  CoreServices.get(`/get_block_customer_contact`).then((value: any) => {

    if (value.data.statusCode === 200) {

      dispatch(
        supervisorContactDataSliceActions.blockedContacts({
          blocked_contacts: value.data.getBlockCustomerListRes,
        })
      );

    } else {
      dispatch(
        supervisorContactDataSliceActions.blockedContacts({
          blocked_contacts: [],
        })
      );
    }
  }).catch(() => console.log('customerBlockerror'))
} catch (error) { console.log(error) }
}

export const getBlockContactRequest = (dispatch: any) => {
try {
  CoreServices.get(`/get_block_customer_contact_request`).then((value: any) => {
    if (value.data.statusCode === 200) {
      const data = (value.data.getBlockCustomerRequestListRes).filter((d: any) => d.blockCustomer !== 1)
      dispatch(
        supervisorContactDataSliceActions.blockedContactsRequest({
          blocked_contactsRequest: data,
        })
      );


    } else {
      dispatch(
        supervisorContactDataSliceActions.blockedContactsRequest({
          blocked_contactsRequest: [],
        })
      );
    }
  }).catch(() => console.log('customerreqerror'))
} catch (error) {
  console.log(error)
}
}


export const getLiveSessions = (dispatch: any) => {
try {
  CoreServices.get(`/get_agent_tracker`).then((value: any) => {
    if (value.data.statusCode === 200) {
      const response =  value?.data?.agentTrackerRes
      dispatch(agentTrackerActions.liveSessions(response));
    }
  }).catch(() => console.log('getLiveSessions err'))
} catch (error) {
  console.log(error)
}
}

export const getDataOld = async (dispatch: any, payload= { offset:  0, limit : null , search: null ,c_type : null, c_tag: null}) => {
  try {
   const {contactList1, aditionalColumn, aditionalColumnCall} = store.getState()?.supervisorContactData
    const body = {
      limit: payload.limit || 10,
      offset: payload.offset ?? null,
      newCustomer: 0,
      search: payload.search,
      c_type: payload.c_type,
      aditionalColumn: aditionalColumn?.length > 0 ? aditionalColumn?.map((i :any)=> i.columName)?.join() : null,
      c_tag:payload.c_tag
    }
    let finalData :any= []
    let customeContact: any = aditionalColumn;

    await CoreServices.post(body, "/get_customer_conatct_pagination").then(async (value: any) => {

      const tottal = value?.data?.totalCount || 0
      dispatch(supervisorContactDataSliceActions.setOldContactTotalcount(tottal));

      if (value.data.statusCode === 200 && value.data.getConatctListRes?.length > 0) {
        const allData = value.data.getConatctListRes;
        if(!aditionalColumnCall){
          finalData = mapAllDataContacts(allData, aditionalColumn)
          dispatch(
            supervisorContactDataSliceActions.supervisorContactReport({
              contactList1: mapAllDataContacts(allData, aditionalColumn),
            })
          );
          return
        }
        await CoreServices.get(`/get_custom_contact`).then((value: any) => {
          if (value.data.statusCode === 200 && value.data.result[0].length > 0) {
            customeContact = value.data.result[0];
            finalData = mapAllDataContacts(allData, value.data.result[0]);
            dispatch(supervisorContactDataSliceActions.setAditionalColumn(value.data.result[0]));
            dispatch(supervisorContactDataSliceActions.setAditionalColumnCall(false));
            dispatch(
              supervisorContactDataSliceActions.supervisorContactReport({
                contactList1: finalData,
              })
            );
          } else {
            finalData = mapAllDataContacts(allData, [])
            dispatch(supervisorContactDataSliceActions.setAditionalColumnCall(false));
            dispatch(
              supervisorContactDataSliceActions.supervisorContactReport({
                contactList1: finalData,
              })
            );
          }
        })
      } else {
        dispatch(supervisorContactDataSliceActions.supervisorContactReport({ contactList1: [] }));
      }
    }).catch((error: any) => { console.log(error) })

    return [finalData, customeContact]

  } catch (error) {
    console.log(error)
    return []
  }
}

export const getDataNew = async (dispatch: any, payload :any= { offset:  0, limit : null , search: null ,c_type : null, c_tag: null}) => {
  try {
    const { newContactList, aditionalColumn, aditionalColumnCall } = store.getState()?.supervisorContactData
    let customeContact: any = aditionalColumn;
    let finalData  :any= []
    const body = {
      limit: payload.limit || 10,
      offset: payload.offset ?? null,
      newCustomer: 1,
      search: payload.search,
      c_type: payload.c_type,
      aditionalColumn: aditionalColumn?.length > 0 ? aditionalColumn?.map((i :any)=> i.columName)?.join() : null,
      c_tag:payload.c_tag
    }
    await CoreServices.post(body, "/get_customer_conatct_pagination").then(async (value: any) => {      
      const tottal = value?.data?.totalCount || 0
      dispatch(supervisorContactDataSliceActions.setNewContactTotalcount(tottal));

      if (value.data.statusCode === 200 && value.data.getConatctListRes?.length > 0) {
        const allData = value.data.getConatctListRes
        if(!aditionalColumnCall){
          finalData = mapAllDataContacts(allData, aditionalColumn)
          dispatch(
            supervisorContactDataSliceActions.supervisorContactReport({
              newContactList: finalData,
            })
          );
          return
        };
        await CoreServices.get(`/get_custom_contact`).then((value: any) => {
          if (value.data.statusCode === 200 && value.data.result[0].length > 0) {
            customeContact = value.data.result[0]
            finalData = mapAllDataContacts(allData, value.data.result[0])
            dispatch(supervisorContactDataSliceActions.setAditionalColumn(value.data.result[0]));
            dispatch(supervisorContactDataSliceActions.setAditionalColumnCall(false));
            dispatch(
              supervisorContactDataSliceActions.supervisorContactReport({
                newContactList: finalData,
              })
            );
          } else {
            finalData = mapAllDataContacts(allData, [])
            dispatch(supervisorContactDataSliceActions.setAditionalColumnCall(false));
            dispatch(
              supervisorContactDataSliceActions.supervisorContactReport({
                newContactList: finalData,
              })
            );
          }
        })
      } else {
        dispatch(supervisorContactDataSliceActions.supervisorContactReport({ newContactList: [] }));
      }
    }).catch((error: any) => { console.log(error) })

    return [finalData ,customeContact]
  } catch (error) {
    console.log(error)
    return []
  }
}

export const mapAllDataContacts = (datas: any, temp_123: any) => {
try {
  const maped = datas?.map((data: any) => {
    let tags = [] as any
    let email = [] as any
    let phoneNumber = [] as any
    let json_obj = {} as any
    for (let data1 of temp_123) {
      json_obj = { ...json_obj, [data1.columName]: data[data1.columName] }
    }
    try {
      let parsed = JSON.parse(data.tags)
      tags = Array.isArray(parsed)
        ?  parsed.filter((d: any) => d && d !== 'null' && d !== 'undefined')
        :  [parsed] || []
    } catch {
      tags = data.tags && data.tags !== "" && data.tags !== 'null' && data.tags !== 'undefined' ? [data.tags] : [];
    }

    try {
      const parsedEmail = JSON.parse(data.email)
      email = Array.isArray(parsedEmail)
        ? parsedEmail.filter((d)=> emailPattern.test(d))
        : emailPattern.test(parsedEmail) ?  [parsedEmail] : []
    } catch {
        email = (data.email && emailPattern.test(data.email)) ? [data.email] : []
    }

    try {
      let parsedPhone =  JSON.parse(data.phoneNumber) 
      phoneNumber = Array.isArray(parsedPhone) ? parsedPhone.filter((d)=> numnberPattern.test(d)) : [data.phoneNumber]
    } catch {
      phoneNumber = data.phoneNumber && numnberPattern.test(data.phoneNumber) ? [data.phoneNumber] : []
    }

    return (
      {
        coid: data.coid,
        firstName: data.firstName && data.firstName !== 'undefined' && data.firstName !== 'null' ? data.firstName : '',
        lastName: data.lastName && data.lastName !== 'undefined' && data.lastName !== 'null' ? data.lastName : '',
        address: data.address && data.address !== 'undefined' && data.address !== 'null' ? data.address : '',

        blockCustomer: data.blockCustomer,
        blockCustomerReq: data.blockCustomerReq,
        doNotDisturb: data.doNotDisturb,
        doNotDisturbReq: data.doNotDisturbReq,

        city: data.city && data.city !== 'undefined' && data.city !== 'null' ? data.city : '',
        country: data.country && data.country !== 'undefined' && data.country !== 'null' ? data.country : '',
        customerType: data.customerType && data.customerType !== 'undefined' && data.customerType !== 'null' && data.customerType ? data.customerType : '',
        email: email.filter((d: any) => d != null),
        facebook: data.facebook !== 'undefined' && data.facebook !== 'null' && data.facebook ? data.facebook : '',
        instagram: data.instagram !== 'undefined' && data.instagram !== 'null' && data.instagram ? data.instagram : '',
        location: data.location !== 'undefined' && data.location !== 'null' && data.location ? data.location : '',
        phoneNumber: phoneNumber.filter((d: any) => d != null),
        postalCode: data.postalCode !== 'undefined' && data.postalCode !== 'null' && data.postalCode ? data.postalCode : '',
        state: data.state !== 'undefined' && data.state !== 'null' && data.state ? data.state : '',
        tags: tags.filter((d: any) => d),
        voiceBiometric: data.voiceBiometric !== 'undefined' && data.voiceBiometric !== 'null' && data.voiceBiometric ? data.voiceBiometric : '',
        whatsapp: data.whatsapp != 'undefined' && data.whatsapp != 'null' && data.whatsapp ? data.whatsapp : '',
        mergeCustomer: data?.mergeCustomer,
        Source: data?.Source || '',
        ...json_obj
      }
    )
  })
  return maped
} catch (error) {
  console.log(error)
  return []
}
}